import useMediaQuery from "@mui/material/useMediaQuery";
import { Dialog, Select, SelectOption } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import { Occurrence } from "../../../../../models/occurrence";
import { useTasOccurrence } from "../../../../../hooks/useTasOccurrence";

export interface ITasForm {
    hiddenFields: string[];
    disabledAllFields?: boolean;
    occurrence: Occurrence | null;
    hasError?: boolean;
    requiredFields: string[];
    setOccurrenceValue: (attr: string, value: any) => void;
}

export const TasForm = (props: ITasForm) => {
    const intl = useIntl();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const {
        detailsLoading,
        tasOccurrences,
        tasOccurrence,
        tasOccurrenceDetails,
        tasOccurrenceDialog,
        setTasOccurrenceDialog,
    } = useTasOccurrence(props.occurrence?.vehicleChassis || '', props.occurrence?.tasNumber || '');

    return (
        <>
            <div
                className={`flex justify-between w-full gap-6 ${isMobile ? "flex-wrap" : ""
                    }`}
            >
                {props.hiddenFields.includes("tasNumber") ? null : (
                    <div
                        className={`form-group form-group-lg w-full ${props.hasError &&
                            props.requiredFields.includes("tasNumber") &&
                            !props.occurrence?.tasNumber
                            ? "has-error"
                            : ""
                            }`}
                    >
                        <label htmlFor="tasNumber" className="truncate">
                            {intl.formatMessage({ id: "intl-msg:kanban.form.tasForm.tasNumber" })}
                            {props.requiredFields.includes("tasNumber") ? " *" : ""}
                        </label>
                        <Select
                            id="tasNumber"
                            value={[props.occurrence?.tasNumber ?? "undefined"]}
                            options={[
                                { id: "undefined", label: intl.formatMessage({ id: "intl-msg:kanban.form.tasForm.selectTasTicket" }) },
                                ...tasOccurrences.map((tas) => ({
                                    id: tas.tasOccurrenceNumber,
                                    label: tas.tasOccurrenceNumber,
                                })),
                            ].filter(Boolean) as SelectOption[]}
                            useFilter
                            onChange={(e) => {
                                props.occurrence &&
                                    props.setOccurrenceValue("tasNumber", e?.id === "undefined" ? undefined : e?.id);
                            }}
                            disabled={props.disabledAllFields}
                        />
                    </div>
                )}

                {props.hiddenFields.includes("tasStatus") ? null : (
                    <div
                        className={`form-group form-group-lg w-full ${props.hasError &&
                            props.requiredFields.includes("tasStatus") &&
                            !props.occurrence?.tasStatus
                            ? "has-error"
                            : ""
                            }`}
                    >
                        <label htmlFor="tasStatus" className="truncate">
                            {intl.formatMessage({ id: "intl-msg:kanban.form.tasForm.tasStatus" })}
                        </label>
                        <input
                            id="tasStatus"
                            className="form-control"
                            value={tasOccurrence?.status ?? "-"}
                            disabled={true}
                        />
                    </div>
                )}
            </div>

            {detailsLoading ? <div className="flex items-center justify-center text-center h-full mb-8"><div className="spinner mt-1"><div/><div/><div/><div/></div></div> : null}

            {tasOccurrence?.tasOccurrenceNumber && !detailsLoading ? <div
                onClick={() => setTasOccurrenceDialog(true)}
                className="text-size-14 text-color-primary font-bold cursor-pointer mb-8 w-full text-center"
            >{intl.formatMessage({ id: "intl-msg:kanban.form.tasForm.viewTasTicketDetails" })}</div> : null}

            <Dialog
                show={tasOccurrenceDialog}
                title={intl.formatMessage({ id: "intl-msg:kanban.form.tasForm.tasTicketDetails" })}
                onClose={() => setTasOccurrenceDialog(false)}
                body={
                    <>
                        {tasOccurrenceDetails
                            .filter(detail => detail.value)
                            .map((detail) => (
                                <div className="mb-6">
                                    <div className="font-bold text-size-12">{detail.label}</div>
                                    <div className="text-size-14">
                                        {detail.value}
                                    </div>
                                </div>
                            ))}
                    </>
                }
            />
        </>
    );
};